// extracted by mini-css-extract-plugin
export default {"page":"Login_page__M50J9","buttons":"Login_buttons__k2R7X","form":"Login_form__bLN41"};